import { generateUtilityClasses, tabsClasses as muiTabsClasses } from '@mui/material';

export { muiTabsClasses };

export const tabsClasses = generateUtilityClasses('Tabs', [
  'root',
  'addButton',
  'item',
  'itemLabel',
  'itemCount',
  'itemInfoButton',
]);
